export var PromptSessionStatus;
(function (PromptSessionStatus) {
    PromptSessionStatus["Idle"] = "Idle";
    PromptSessionStatus["Running"] = "Running";
    PromptSessionStatus["Completed"] = "Completed";
    PromptSessionStatus["Error"] = "Error";
    PromptSessionStatus["Cached"] = "Cached";
})(PromptSessionStatus || (PromptSessionStatus = {}));
export var TimelineStepKind;
(function (TimelineStepKind) {
    TimelineStepKind["ToolUse"] = "tool-use";
    TimelineStepKind["Reasoning"] = "reasoning";
    TimelineStepKind["TextOutput"] = "text-output";
})(TimelineStepKind || (TimelineStepKind = {}));
//# sourceMappingURL=prompt.js.map